import { render, staticRenderFns } from "./amazonGoods.vue?vue&type=template&id=69a5ee40&scoped=true"
import script from "./amazonGoods.vue?vue&type=script&lang=js"
export * from "./amazonGoods.vue?vue&type=script&lang=js"
import style0 from "./amazonGoods.vue?vue&type=style&index=0&id=69a5ee40&prod&scoped=true&lang=less"
import style1 from "./amazonGoods.vue?vue&type=style&index=1&id=69a5ee40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a5ee40",
  null
  
)

export default component.exports